import { useState } from "react";
import { Button, Drawer, Modal, Tag, message } from "antd";
import { useTranslation } from "react-i18next";
import { DeleteOutlined, PlusCircleOutlined, ShopFilled } from "@ant-design/icons";
import { authFetch } from "../../../../../common/request/authFetch";
import { useAuth } from "../../../../../store/AuthContext/AuthContext";
import { ButtonLZ } from "../../../../components/design/Buttons/ButtonLZ";
import { NewPlaceKeywordModal } from "./NewPlaceKeywordModal";
import { DrawerPanelTitle, drawerPanelStyles } from "../../../common/Drawers/DrawerPanelTitle";

export const PlaceKWDrawer = (props: { place: any, onFinish: any}) => {    
    
    const [openModal, setOpenModal] = useState<boolean>(false);
    const { projectGroup } = useAuth();

    const { t } = useTranslation();
    
      const deleteReply = async (kw: string): Promise<void> => {

        const data = {        
            keyword: kw,            
        };
        
        await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/places/${props.place?.id}/keywords`, { method: 'DELETE', data: data })
            .then((res) => {
                if (res) {
                    message.success('Keyword borrada de forma satisfactoria', 3);
                    props.onFinish();
                } else {
                  message.error('Problema al borrar la keyword', 3);
                }
            })
        }    

    return (        
        <Drawer
            placement="right"
            width={'50%'}
            open={true}            
            onClose={props.onFinish}
            {...drawerPanelStyles}
            title={<DrawerPanelTitle title={props.place?.title} />}>

            <h3 style={{color:'black'}}>Keywords a analizar: </h3>

            {props.place?.keywords?.map((kw: any, index: number)=>(
                  <div style={{display:'flex', justifyContent:'space-between', alignItems: 'center', margin:'0px 100px'}}>
                    <Tag icon={<ShopFilled/>} style={{cursor: 'pointer', padding:'2px 6px', margin:'3px', fontSize:'12px', background: 'teal', color: 'white', minWidth:'120px'}} color="white">{kw}</Tag>    							
                    <Button shape='round' size='small' type='ghost'
                      onClick={() => {
                            Modal.confirm({
                                title: 'Confirmas que quieres eliminar esta keyword',
                                okText: t('dictionary.confirm'),
                                cancelText: t('dictionary.cancel'),
                                onOk: () => deleteReply(kw)
                            })
                        }}>
                      <DeleteOutlined/>
                    </Button>
                  </div>
                ))
            }    
            <div style={{ display: 'flex', justifyContent:'flex-end', gap: '10px', alignItems: 'center', marginTop: '16px', marginBottom: '16px' }}>
              <ButtonLZ onClick={() => { setOpenModal(true) }} size="small">
                  <PlusCircleOutlined/> Añadir keyword
              </ButtonLZ>
            </div>       
            {openModal && <NewPlaceKeywordModal place={props.place} onFinish={() => { setOpenModal(false); props.onFinish()}} />} 
        </Drawer>                
    );
};
